export const update = ({deleted, tags}: {deleted: string[], tags: Record<string, string>}) => ({
  type: 'TAGS_UPDATE' as const,
  deleted,
  tags
});
